import { Box, IconArrowRight16, Stack, Text } from '@stitch-fix/mode-react';
import { Link } from '@stitch-fix/sf-next';
export const OtherActions = () => {
  return <Box>
      <Text setting="body-medium">You can also</Text>
      <Box ml={1}>
        <Stack spacing={0.5}>
          <Link size="tertiary" href="https://www.stitchfix.com/client/referrals" endIcon={<IconArrowRight16 />}>
            See My Referrals
          </Link>
          <Link size="tertiary" href="/gifts" endIcon={<IconArrowRight16 />}>
            Redeem a gift code
          </Link>
        </Stack>
      </Box>
    </Box>;
};